import React, { useEffect, useState } from "react";
import HomeTable from "../../components/table/HomeTable";
import { SectionRow } from "./../../layouts/sections/index";
import StatCard from "./../../components/cards/statCard";
import {
	STAT_ACCENT_COLORS,
	STAT_ICON_PATHS,
	setStakeholderTypes,
	STAKEHOLDERS,
} from "./../../app/constants";
import { useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { navigateNewTab, navigateSelf } from "../../app/router/routerManager";
import { CERTIFICATION_BODY_ROUTES, FIELD_VISIT_ROUTES } from "../../app/router/routes";
import { deleteStepper } from "./../../components/stepper/dynamicStepper";

import { setApplicationStage, showViewIcon } from "../../components/table/tableHelpers";
import {
	getDistrict,
	getDivisionalSecretariatName,
	getGramaNiladhariDivisions,
	getTableCounts,
	getTableRecords,
} from "./../../app/api/NOCU/tableAPI";

import { setStakeholderType } from "../../app/api/NOCU/helpers/applicationApiHelpers";
import { getUserId } from "./../../app/api/NOCU/helpers/applicationApiHelpers";
import { getTableData } from "../certificationBody/dataManipulation";
import { SectionColumn } from "../../components/section";
import CommonSelection from "../../components/section/commonSelection";
import { setDropdownValue, setDropdownValueReactSelect } from "../../Helpers/dropdownHelper";
import SelectionFilter from "../../components/section/selectionFilter";
import NextButton from "../../components/buttons/nextButton";
import SearchButton from "../../components/buttons/searchButton";
import ResetButton from "../../components/buttons/resetButton";
import SearchBar from "../../components/search/searchBar";
import FilterCard from "../../components/cards/filterCard";
import LoaderComponent from "../../components/Loader/LoaderComponent";
import { deleteIsRenewal, setIsRenewal } from "../../components/navbar/helpers";

const FieldVisitHome = () => {
	const { id } = useParams();
	const [records, setRecords] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [counts, setCounts] = useState({
		pendingCount: 0,
		approvedCount: 0,
		rejectedCount: 0,
		resubmissionCount: 0,
	});
	const [selectedCount, setSelectedCount] = useState();
	const [selectedTitle, setSelectedTitle] = useState("New Requests");
	const [tableCount, setTableCount] = useState();
	const [res, setRes] = useState();

	const tableHeaders = [
		"Name",
		"Application No.",
		"Com. Reg. No.",
		"Business type",
		"Contact Person",
		"Date & Time",
		"Type",
	];
	const rowsData = [
		[
			"Coco Tech",
			"CER32627703",
			"BT5678",
			"Export",
			"cocotech@gmail.com",
			"Suran Mendis 0778962383",
			"02-12-2022 13.23",
		],
		[
			"Bpoi Trades",
			"CER32627707",
			"BT5324",
			"Import",
			"bophi@gmail.com",
			"Sudantha Perera 0778962383",
			"02-12-2022 13.23",
		],
		[
			"Coco Tech",
			"CER32627708",
			"BT5678",
			"Export",
			"cocotech@gmail.com",
			"Suran Mendis 0778962383",
			"02-12-2022 13.23",
		],
		[
			"Coco Tech",
			"CER32627709",
			"BT5678",
			"Export",
			"cocotech@gmail.com",
			"Suran Mendis 0778962383",
			"02-12-2022 13.23",
		],
	];
	const [districts, setDistricts] = useState([]);
	const [tableFilters, setTableFilters] = useState({
		districtName: "",
		divisionalSecretariatName: "",
	});
	const [divisionalSecretariat, setDivisionalSecretariat] = useState([]);
	const [gramaNiladhariDivisions, setGramaNiladhariDivisions] = useState([]);
	let filters = [
		{ key: "PENDING", value: "PENDING" },
		{ key: "SUCCESS", value: "SUCCESS" },
		{ key: "SUSPENDED", value: "SUSPENDED" },
		{ key: "APPROVED", value: "APPROVED" },
		{ key: "REJECTED", value: "REJECTED" },
	];
	let sorting = [
		{ key: "Acceding", value: true },
		{ key: "Descending", value: false },
	];
	const [selectedStatCard, setSelectedStatCard] = useState(1);
	const [params, setParams] = useState({
		status: "",
		isAscending: true,
		page: 0,
		size: 5,
		officerId: getUserId(),
		stakeholderType: "ALL",
		applicationStage: "FIELD_VISIT",
		applicationNumber: "",
		district: "",
		divisionalSecretariat: "",
		gramaNiladhariDivision: "",
	});

	const [searchParams, setSearchParams] = useState({
		status: "",
		isAscending: true,
		page: 0,
		size: 5,
		officerId: getUserId(),
		stakeholderType: "ALL",
		applicationStage: "FIELD_VISIT",
		applicationNumber: "",
		district: "",
		divisionalSecretariat: "",
		gramaNiladhariDivision: "",
	});

	useEffect(() => {
		setSelectedStatCard(parseInt(id));
		if (parseInt(id) === 1) {
			setParams({ ...params, status: "PENDING" });
			setSearchParams({ ...searchParams, status: "PENDING" });
			setSelectedCount(counts.pendingCount);
			setSelectedTitle("Pending Field Visits");
		} else if (parseInt(id) === 2) {
			setParams({ ...params, status: "RESUBMIT" });
			setSearchParams({ ...searchParams, status: "RESUBMIT" });
			setSelectedCount(counts.resubmissionCount);
			setSelectedTitle("Pending Field Visits");
		} else if (parseInt(id) === 3) {
			setParams({ ...params, status: "APPROVED", isAscending: false });
			setSearchParams({ ...searchParams, status: "APPROVED", isAscending: false });
			setSelectedCount(counts.approvedCount);
			setSelectedTitle("Pending Field Visits");
		} else if (parseInt(id) === 4) {
			setParams({ ...params, status: "REJECTED" });
			setSearchParams({ ...searchParams, status: "REJECTED" });
			setSelectedCount(counts.rejectedCount);
			setSelectedTitle("Rejected Requests");
		}
	}, [id]);
	const handleFilter = (filter) => {
		setParams({ ...params, status: filter });
	};

	const handleStakeHolderType = (filter) => {
		setParams({ ...params, stakeholderType: filter });
		setSearchParams({ ...searchParams, stakeholderType: filter });
	};

	const handleApplicationID = (filter) => {
		setSearchParams({ ...searchParams, applicationNumber: filter });
	};

	const handleDistrictFilter = (filter) => {
		setSearchParams({ ...searchParams, district: filter });
		setTableFilters({ ...tableFilters, districtName: filter });
	};

	const handleDivisionalSecretariatFilter = (filter) => {
		setSearchParams({ ...searchParams, divisionalSecretariat: filter });
		setTableFilters({ ...tableFilters, divisionalSecretariatName: filter });
	};

	const handleGramaNiladhariDivisionFilter = (filter) => {
		setSearchParams({ ...searchParams, gramaNiladhariDivision: filter });
	};

	const handleSorting = (isAscending) => {
		setParams({ ...params, isAscending: isAscending });
	};
	const handlePage = async (page) => {
		setSearchParams({ ...searchParams, page: page });
		setParams({ ...params, page: page });
		handleSearchParams(page, params.size);
	};
	const handleSize = (size) => {
		setParams({ ...params, size: size, page: 0 });
		setSearchParams({ ...searchParams, size: size });
		handleSearchParams(0, size);
	};
	const handleSearchById = (id) => {
		setParams({ ...params, applicationNumber: id });
	};

	const viewFunction = (index) => {
		setStakeholderType(res.applicationList[index]?.stakeholderType);
		setApplicationStage(params.applicationStage);
		setIsRenewal(res.applicationList[index]?.isRenewal);
		navigateSelf(FIELD_VISIT_ROUTES.REVIEW);
	};
	const historyFunction = (index) => {
		console.log("Index Of record=================>", index);
	};

	useEffect(() => {
		deleteIsRenewal();
		const params = {
			officerId: getUserId(),
			stakeholderType: searchParams.stakeholderType,
			applicationNumber: searchParams.applicationNumber,
			applicationStage: "FIELD_VISIT",
		};
		setStakeholderType(setStakeholderTypes.CERTIFICATION_BODY);
		getTableCounts(params).then((res) => {
			setCounts(res);
		});
		getDistrict().then((res) => {
			setDistricts(setDropdownValueReactSelect(res));
		});
	}, []);

	useEffect(() => {
		getDivisionalSecretariatName(tableFilters).then((res) => {
			setDivisionalSecretariat(setDropdownValueReactSelect(res));
		});
	}, [tableFilters.districtName]);

	useEffect(() => {
		getGramaNiladhariDivisions(tableFilters).then((res) => {
			setGramaNiladhariDivisions(setDropdownValueReactSelect(res));
		});
	}, [tableFilters.divisionalSecretariatName]);

	useEffect(() => {
		!!!selectedCount && setSelectedCount(counts.pendingCount);
	}, [counts]);

	useEffect(() => {
		console.log("Params ====>", params);
		if (params.status && params.status !== "") {
			getTableRecords(params)
				.then((res) => {
					console.log("Res ======> ", getTableData(res.data));
					setRecords(getTableData(res.data));
					setRes(res.data);
					setTableCount(res?.data.count);
				})
				.then((e) => console.log(e))
				.finally(() => {
					setIsLoading(false);
				});
		}
	}, [params]);

	const handleSearchParams = async (page, size) => {
		let _searchParam = searchParams;
		_searchParam.page = page;
		_searchParam.size = size;
		getTableRecords(_searchParam)
			.then((res) => {
				console.log("Res ======> ", getTableData(res.data));
				setRecords(getTableData(res.data));
			})
			.then((e) => console.log(e))
			.finally(() => {
				setIsLoading(false);
			});
	};

	return (
		<div>
			<LoaderComponent isOpen={isLoading} />

			<SectionRow className='mt-0'>
				<span className='overViewTitle'>Field Visit</span>
			</SectionRow>
			<SectionRow className='w-full'>
				<SectionRow className='w-full overflow-x-auto overflow-y-hidden mb-5 customScrollBar'>
					<SectionRow className='w-full !min-w-max mb-2 justify-start items-start'>
						<StatCard
							value={counts?.pendingCount}
							text={"Pending Field Visit"}
							image={STAT_ICON_PATHS.stat_upload_verification}
							accent={STAT_ACCENT_COLORS.darkGreen}
							handleStatCard={() => {}}
							num={1}
							selected={selectedStatCard}
							setSelectStatCard={setSelectedStatCard}
						/>
						<StatCard
							value={counts?.approvedCount}
							text={"Completed Field Visit"}
							image={STAT_ICON_PATHS.stat_checkMark}
							accent={STAT_ACCENT_COLORS.lightGreen}
							handleStatCard={() => {}}
							num={3}
							selected={selectedStatCard}
							setSelectStatCard={setSelectedStatCard}
						/>
						<FilterCard
							leftTop={
								<SelectionFilter
									filters={districts}
									onChange={handleDistrictFilter}
									placeholder='Select District'
								/>
							}
							rightTop={
								<SelectionFilter
									filters={divisionalSecretariat}
									onChange={handleDivisionalSecretariatFilter}
									placeholder='Select Divisional Secretariat'
								/>
							}
							leftBottom={
								<SelectionFilter
									filters={gramaNiladhariDivisions}
									onChange={handleGramaNiladhariDivisionFilter}
									placeholder='Select Grama Niladhari Division'
								/>
							}
							handleSearchParams={handleSearchParams}
						/>
					</SectionRow>
				</SectionRow>
				{/* <div className="w-3/5 mb-5">
					<SectionColumn className = "my-auto">
						<SectionRow className = "w-full justify-end space-x-3">
							<SelectionFilter filters={districts} onChange={handleDistrictFilter} title={"Filter By District"} placeholder = "Select Opion" />
							<SelectionFilter filters={divisionalSecretariat} onChange={handleDivisionalSecretariatFilter} title={"Filter By Divisional Secretariat"} placeholder = "Select Opion" />
						</SectionRow>
						<SectionRow className = "w-full justify-end">
							<SelectionFilter filters={gramaNiladhariDivisions} onChange={handleGramaNiladhariDivisionFilter} title={"Filter By GramaNiladhari Division"} placeholder = "Select Opion" />
							<SelectionFilter filters={STAKEHOLDERS} onChange={handleStakeHolderType} title={"Filter By Stakeholder Type"} selected = "ALL" />
						</SectionRow>
						<SectionRow className = "w-full justify-end">
							<SearchBar onChange={handleApplicationID} title={"Filter By Application ID"} placeholder = "Select Opion" />
						</SectionRow>

						<SectionRow className="w-full justify-end space-x-4">
						<ResetButton
								className={"search-btn"}
								path = {FIELD_VISIT_ROUTES.HOME + "/1"}
								name='Reset'
								title='Reset'
								color={""}
								disabled={false}
							/>
							<SearchButton
								className={"search-btn"}
								handleClick={handleSearchParams}
								name='Search'
								title='Search'
								color={""}
								disabled={false}
							/>
						</SectionRow>

					</SectionColumn>
				</div> */}
			</SectionRow>

			<HomeTable
				applicationKey={1}
				columns={tableHeaders}
				handleSearchById={handleSearchById}
				// tableTitle={selectedTitle}
				rows={records}
				view={showViewIcon(["1"], id) ? viewFunction : null}
				// history={historyFunction}
				filters={STAKEHOLDERS}
				setFilter={handleStakeHolderType}
				// sort={sorting}
				handleSort={handleSorting}
				handleSize={handleSize}
				count={tableCount}
				page={params.page}
				size={params.size}
				handlePage={handlePage}
				filterTitle='Stakeholder'
			/>
		</div>
	);
};

export default FieldVisitHome;
